import React from "react"
import "./FeedbackButton.css"

const FeedbackButton = () => {
    return (
        <div className="feedback-button btn btn-dark">
            <a className="text-white text-decoration-none" href="mailto:contact@cinetimes.org?subject=Cinetimes%20Feedback">
                Feedback
            </a>
        </div>
    )
}

export default FeedbackButton